import { useTranslation } from 'react-i18next';
import { Button, Select } from '../../controls';
import i18next from 'i18next';
import { DISPATCHER_URL, SMALL_DEVICE_WIDTH } from '../../../../utils/constants/constants';
import { useWindowDimensions } from '../../../../hooks/useWindowDimensions';
import { Language } from '../../../../i18n';
import rlDispatcherLogo from '../../../../assests/img/rl-dispatcher-logo.svg';
import { CustomUserEvents, InitiatedFrom } from '../../../../logic/CustomUserEvents';

interface Props {
    languages: Language[];
}

const AppNavigation = (props: Props) => {
    const { t } = useTranslation();
    const { width } = useWindowDimensions();

    function onClickPromoButton() {
        CustomUserEvents.tryDispatcherButton(InitiatedFrom.HEADER_SHARE_BUTTON);
        window.open(DISPATCHER_URL, '_blank');
    }

    return (
        <nav className="rl-navbar">
            <div className="rl-navbar-logo">
                <img src={rlDispatcherLogo} alt="RoadLords Share ETA" />
            </div>

            <div className="right-items">
                <Button id="connect-drivers-button" type="secondary" outline={true} onClick={onClickPromoButton}>
                    {t('NavBar.tryDispatcher')}
                </Button>
                <Select
                    value={i18next.language}
                    onChange={(lang: string) => i18next.changeLanguage(lang)}
                    dropdownMatchSelectWidth={false}
                    optionLabelProp="label"
                    dropdownAlign={{
                        points: ['tr', 'br'],
                        offset: [0, width <= SMALL_DEVICE_WIDTH ? 5 : 13],
                        overflow: {
                            adjustX: true,
                            adjustY: true
                        }
                    }}
                >
                    {props.languages?.map((lang, index) => (
                        <Select.Option key={index} value={lang.code} label={lang.label}>
                            {`${lang.label} - ${lang.name}`}
                        </Select.Option>
                    ))}
                </Select>
            </div>
        </nav>
    );
};

export default AppNavigation;
